import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Tooltip,
} from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons'; 
import React, { useEffect, useState } from "react";
import moment from "moment";

import service from "../../services/citizenScienceLookupService";
import commonLookupService from "src/services/commonLookupService";

import { MinusCircleOutlined } from "@ant-design/icons";
import {
  citizenScienceStatusEnum,
  booleanEnum,
  openNotification,
  Messages,
  Notify,
  util
} from "@seims/shared";

import { recordError } from "src/utils/logService";

export default function ProjectDetails({
  onSetNextStatus,
  formRef,
  formData,
  onFormValuesChange,
}) {
  const [scienceFields, setScienceFields] = useState([]);
  const [scienceDomains, setScienceDomains] = useState([]);
  const [objectives, setObjectives] = useState([]);
  const [disseminations, setDisseminations] = useState([]);
  const [checkedObjectiveList, setCheckedObjectiveList] = useState([]);
  const [checkedRoleList, setCheckedRoleList] = useState([]);
  const [showOtherObjective, setShowOtherObjective] = useState(false);
  const [showOtherDissemination, setShowOtherDissemination] = useState(false);
  const [selectedScienceShop, setSelectedScienceShop] = useState("");
  const [booleanOptions, setBooleanOption] = useState([
    { value: "Yes", key: true },
    { value: "No", key: false },
  ]);
  const [isScienceShop, setIsScienceShop] = useState(false);
  const [selectedProvinces, setSelectedProvinces] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [district, setDistrict] = useState();
  const [districts, setDistricts] = useState([]);
  const [towns, setTowns] = useState([]);
  const [current, setCurrent] = useState([]);
  const dateFormat = "YYYY-MM-DD";
  const { TextArea } = Input;
  const formItemLayout = {
    labelCol: {
      span: 18,
    },
    wrapperCol: {
      span: 20,
    },
    layout: "vertical",
  };
  useEffect(() => {
    getScienceFields();
    getObjectives();
    getprovinceData();
    getDisseminationApproaches();
  }, [checkedObjectiveList, onFormValuesChange]);

  useEffect(() => {
    prePopulate();
  }, [formRef]);

  const prePopulate = async () => {
    if (!util.isEmpty(formData)) {
      try {
        var scienceDomains;

        if (formData.scienceDomain) {
          const { key } = formData.scienceFields;
          const response = await service.getScienceDomainsByFields(key);
          if (response && response.status === 200) {
            const { data } = response;
            scienceDomains = formData?.scienceDomain.map((k) => k.toString());
            setScienceDomains(data);

            form.setFieldsValue({
              scienceDomain: scienceDomains,
            });
          }
        }

        if (formData?.otherObjective) {
          setShowOtherObjective(true);
        } else {
          setShowOtherObjective(false);
        }

        if (formData?.otherDissemination) {
          setShowOtherDissemination(true);
        } else {
          setShowOtherDissemination(false);
        }

        form.setFieldsValue({ location: formData.location });
      } catch (error) {}
    }
  };

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "ProjectDetails";

  const [value, setValue] = useState(1);
  const onChange = () => {
  };

  const getScienceFields = async () => {
    try {
      const response = await service.getScienceFields();
      if (response && response.status === 200) {
        const { data } = response;
        setScienceFields(data);
      }
    } catch (error) {
      recordError(error);
    }
  };
  const getObjectives = async () => {
    try {
      const response = await service.getObjectives();
      if (response && response.status === 200) {
        const { data } = response;

        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));
        setObjectives(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const getDisseminationApproaches = async () => {
    try {
      const response = await service.getDisseminationApproaches();
      if (response && response.status === 200) {
        const { data } = response;

        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key,
          key: c.key,
        }));

        setDisseminations(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getprovinceData = async () => {
    try {
      const response = await commonLookupService.getProvincesDistrictTowns();
      if (response && response.status === 200) {
        const { data } = response;
        setProvinces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const handleProvinceChange = (value, namePath) => {
    const selectedProvince = provinces.find((record) => record.value === value);

    const currentLocation = form.getFieldValue(["location", namePath]);

    if (Array.isArray(currentLocation)) {
      const isDuplicate = currentLocation.some(
        (location, index) =>
          location?.province?.value === value && index !== namePath
      );

      if (isDuplicate) {
        const msg = "This province has already been selected in another row.";
        openNotification("Duplicate Location Selected", msg, Notify.ERROR);
        return;
      }
    }

    form.setFieldsValue({
      location: {
        ...currentLocation,
        [namePath]: {
          province: {
            key: selectedProvince.key,
            value: selectedProvince.value,
          },
          district: undefined,
          town: undefined,
        },
      },
    });
    setDistricts(selectedProvince.districts);
    setTowns([]);
  };
  const handleDistrictChange = (value, namePath) => {

    const currentLocation = form.getFieldValue(["location", namePath]);

    if (Array.isArray(currentLocation)) {
      const isDuplicate = currentLocation.some(
        (location, index) =>
          location?.district?.value === value && index !== namePath
      );

      if (isDuplicate) {
        const msg = "This district has already been selected in another row.";
        openNotification("Duplicate Location Selected", msg, Notify.ERROR);
        return;
      }
    }

    const selectedDistrict = districts.find(
      (district) => district.value === value
    );
    form.setFieldsValue({
      location: {
        ...currentLocation,
        [namePath]: {
          ...currentLocation[namePath],
          district: {
            key: selectedDistrict.key,
            value: selectedDistrict.value,
          },
          town: undefined,
        },
      },
    });

    setTowns(selectedDistrict.towns);
  };
  const handleCityChange = (value, namePath) => {
    const selectedTown = towns.find((c) => c.value === value);
    const currentLocation = form.getFieldValue(["location", namePath]);

    if (Array.isArray(currentLocation)) {
      const isDuplicate = currentLocation.some(
        (location, index) =>
          location?.town?.value === value && index !== namePath
      );

      if (isDuplicate) {
        const msg = "This town has already been selected in another row.";
        openNotification("Duplicate Location Selected", msg, Notify.ERROR);
        return;
      }
    }

    form.setFieldsValue({
      location: {
        ...currentLocation,
        [namePath]: {
          ...currentLocation[namePath],
          town: { key: selectedTown.key, value: selectedTown.value },
        },
      },
    });
  };

  const onChangeObjectives = (selectedValue) => {
    const selectedOptions = objectives?.filter((c) =>
      selectedValue.includes(c.key)
    );
    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    if (otherSelected) {
      setShowOtherObjective(true);
    } else {
      setShowOtherObjective(false);
    }
    //? setCheckedObjectiveList(checkedObjectiveList);  NOT SURE WHAT DOES THIS SET DO
  };

  const onChangeRoles = (selectedValue) => {
    const selectedOptions = disseminations?.filter((c) =>
      selectedValue.includes(c.key)
    );

    const otherSelected = selectedOptions.some((c) => c.label === "Other");

    // const otherDissemination = checked.indexOf("Other");
    if (otherSelected) {
      setShowOtherDissemination(true);
    } else {
      setShowOtherDissemination(false);
    }
    // setCheckedRoleList(checkedItem);
    // form.setFieldsValue({approach: checkedItem})
  };

  const onChangeScienceOption = (e) => {
    const { value: selected } = e.target;
    const selectedLocality = booleanOptions.find(
      (record) => record.key === selected
    );

    if (selectedLocality.value == booleanEnum.LOCAL) {
      setIsScienceShop(true);
    } else {
      setIsScienceShop(false);
    }

    setSelectedScienceShop(selected);
  };

  const onSubmit = (values) => {
    onNext(values);
    onSetNextStatus(citizenScienceStatusEnum.ORGANIZATIONS);
  };
  const onNext = async () => {
    try {
      await form.validateFields(["projectTitle", "location"]);
      setCurrent((prev) => prev + 1);
    } catch (error) {}
  };
  const onFinishFailed = () => {};

  const onChangeScienceFields = async (selectedValue) => {
    form.resetFields(["scienceDomain"]);

    try {
      const selectedField = scienceFields.find(
        (c) => c.value === selectedValue
      );
      form.setFieldsValue({ scienceFields: selectedField });

      const response = await service.getScienceDomainsByFields(
        selectedField.key
      );
      if (response && response.status === 200) {
        const { data } = response;
        setScienceDomains(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChangeScienceDomain = (selectedValue) => {
    const selectedDomain = scienceDomains.find(
      (c) => c.key === parseInt(selectedValue)
    );

    form.setFieldsValue({ scienceDomain: selectedDomain });
  };

  const checkDate = () => {
    if (
      form.getFieldsValue().startDate !== undefined &&
      form.getFieldsValue().endDate
    ) {
      const startDate = new Date(
        moment(form.getFieldsValue().startDate).format(dateFormat)
      );
      const endDate = new Date(
        moment(form.getFieldsValue().endDate).format(dateFormat)
      );

      if (startDate > endDate) {
        var msg = util.parseMessage(
          Messages.DATE_ERROR,
          "Start date must not be later than end date"
        );
        openNotification("Project date", msg, Notify.ERROR);
      }
    }
  };

  return (
    <>
      <Card
        className="project-card"
        title={
          <span style={{ color: "black", fontWeight: "bold" }}>
            <b>STEP 2: Project Details</b>
          </span>
        }
        bordered={false}
        headStyle={{ border: 0, textAlign: "left" }}
      >
        <p style={{ textAlign: "left" }}>What is the project about?</p>
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          onFinish={onSubmit}
          scrollToFirstError
          initialValues={formData}
          onFinishFailed={onFinishFailed}
          ref={formRef}
          onValuesChange={onFormValuesChange}
        >
          <Row>
            <Col xs={24} sm={8} md={20}>
              <Form.Item
                name="projectTitle"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Project Title
                    <Tooltip
                      title="Enter A Concise And Descriptive Title For The Project. (Maximum 255 Characters)"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 700, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter project title",
                  },
                  {
                    required: true,
                    min: 3,
                    message: "Please enter a longer title",
                  },
                ]}
              >
                <Input
                  name="projectTitle"
                  onBlur={onNameBlur}
                  showCount
                  maxLength={255}
                  minLength={3}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={20}>
              <Form.Item
                name="description"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                   Description
                    <Tooltip
                      title="Provide a detailed explanation of the project's objectives, methodology, and expected outcomes(Maximum 1500 Characters)"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter project description",
                  },
                  {
                    required: true,
                    min: 5,
                    message: "Please enter a longer description",
                  },
                ]}
              >
                <TextArea
                  name="description"
                  rows={4}
                  placeholder="Please add project description here..."
                  showCount
                  maxLength={1500}
                  minLength={5}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={8} md={8}>
              <Form.Item
                name="scienceFields"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Science Discipline
                    <Tooltip
                      title="Select the broad scientific category that best represents this research project (e.g., Humanities, Social Sciences, Natural Sciences)"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select science discipline",
                  },
                ]}
              >
                <Select onChange={onChangeScienceFields}>
                  {scienceFields.map((field) => (
                    <Option key={field.key} value={field.value}>
                      {field.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={8} md={8}>
              <Form.Item
                name="scienceDomain"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Science Fields
                    <Tooltip
                      title="Specify the specific field(s) of science related to this project (e.g., Marine Biology, Organic Chemistry, Quantum Mechanics)"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select science fields",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onSelect={onChangeScienceDomain}
                  onChange={onChangeScienceDomain}
                >
                  {scienceDomains.map((domain) => (
                    <Option key={domain.key}>{domain.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={8} md={8}>
              <Form.Item
                name="startDate"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Planned Start Date
                    <Tooltip
                      title="Enter the date (past, present or future) when the research project is expected to begin"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format={dateFormat}
                  onChange={checkDate}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8}>
              <Form.Item
                name="endDate"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Planned End Date
                    <Tooltip
                      title="Enter the anticipated completion date (after the start date) of the research project"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format={dateFormat}
                  onChange={checkDate}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={8} md={20}>
              <Form.Item
                style={{ fontWeight: "bold" }}
                name="location"
                // label="Project Location"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Project Location
                    <Tooltip
                      title="Specify an address for the primary location where the project activities will occur (e.g., laboratory, field site, institution)"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select Location values",
                  },
                ]}
              >
                <p style={{ textAlign: "left", fontWeight: "normal" }}>
                  Where is this project located?
                </p>
                <Form.List name="location">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(
                        ({ key, field, name, index, ...restField }) => (
                          <Space
                            key={key}
                            style={{
                              display: "flex",
                              marginBottom: 8,
                              width: "100%",
                            }}
                            align="baseline"
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "province"]}
                              label="Province"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select Province",
                                },
                              ]}
                            >
                              <Select
                                onChange={(value) =>
                                  handleProvinceChange(value, [name])
                                }
                              >
                                {provinces?.map((option) => (
                                  <Option key={option.key} value={option.value}>
                                    {option.value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "district"]}
                              label="District"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select District",
                                },
                              ]}
                            >
                              <Select
                                value={district}
                                onChange={(value) =>
                                  handleDistrictChange(value, [name])
                                }
                              >
                                {districts?.map((dist) => (
                                  <Option key={dist.key} value={dist.value}>
                                    {dist.value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "town"]}
                              label="Nearest Town"
                            >
                              <Select
                                onChange={(value) =>
                                  handleCityChange(value, [name])
                                }
                              >
                                {towns?.map((town) => (
                                  <Option key={town.key} value={town.value}>
                                    {town.value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          </Space>
                        )
                      )}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block>
                          Add Location
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {/* <Col span={8} ></Col> */}
            <Col span={24}>
              <Form.Item
                name="citizenScience"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Was this project conceptualised as Citizen Science project from the beginning?
                    <Tooltip
                      title="Indicate whether this project was designed from the outset to involve public participation in scientific research"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please choose an option",
                  },
                ]}
              >
                <Radio.Group
                  onChange={onChange}
                  value={value}
                  style={{ float: "left", width: "30px", height: "30px" }}
                >
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={18}>
              <Form.Item
                name="objectives"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Objectives
                    <Tooltip
                      title="Select one or more objectives that align with the project’s purpose and intended outcomes"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select objective(s)",
                  },
                ]}
              >
                <Checkbox.Group
                  onChange={onChangeObjectives}
                  options={objectives}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
              {/* {showOtherObjective && (
                <Form.Item
                  name="otherObjective"
                  label="Other Objectives"
                  rules={[
                    {
                      required: true,
                      message: "Please provide other objective",
                    },
                  ]}
                >
                    <Input name="otherObjective" />
                </Form.Item>
              )} */}
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={18}>
              <Form.Item
                name="approach"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Planned Research Dissemination Approach
                    <Tooltip
                      title="Select how the research findings will be shared with different audiences"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select a dissemination approach",
                  },
                ]}
              >
                <Checkbox.Group
                  onChange={onChangeRoles}
                  options={disseminations}
                  style={{ display: "flex", flexDirection: "column" }}
                />
              </Form.Item>
              {/* {showOtherDissemination && (
                <Form.Item
                  name="otherDissemination"
                  label="Other planned research dissemination approach"
                  rules={[
                    {
                      required: true,
                      message:
                        "Please provide Other planned research dissemination approach",
                    },
                    {
                      required: true,
                      min: 5,
                      message:
                        "Minimum of 5 characters is required for other planned research",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              )} */}
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              <Form.Item
                name="scishop"
                label={
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Is the facility at this institution a Science Shop?
                    <Tooltip
                      title="A Science Shop is a facility that provides independent, participatory research in response to societal needs. Indicate if the institution hosting the project operates as a Science Shop"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 200, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Is it a science shop",
                  },
                ]}
                wrapperCol={{ span: 6 }}
              >
                <Radio.Group
                  onChange={onChangeScienceOption}
                  value={selectedScienceShop}
                  style={{ float: "left", width: "30px", height: "30px" }}
                >
                  {booleanOptions.map((option) => (
                    <Radio key={option.key} value={option.key}>
                      {option.value}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
}
